import { useMemo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { GrowthBookProvider } from '@growthbook/growthbook-react';
import { growthbook } from '../types/experiments';
import { HOME_SCHOOL_IDS } from '@/config/settings';

const ExperimentsProvider = ({ children }) => {
  const userId = useSelector(s => s.user?.userId);
  const students = useSelector(s => s.user?.students);

  const mostRecentStudent = useMemo(() => {
    if (!students) {
      return undefined;
    }

    return students
      .filter(student => !HOME_SCHOOL_IDS.includes(student.schoolId))
      .sort(
        (a, b) => new Date(b.dateCreated || 0) - new Date(a.dateCreated || 0)
      )[0];
  }, [students]);

  const activeGroupId = mostRecentStudent?.activeGroupId;
  const schoolId = useSelector(s => s.school?.schoolId);
  useEffect(() => {
    growthbook.setAttributes({
      userId: userId,
      classId: activeGroupId,
      schoolId: schoolId
    });
  }, [userId, activeGroupId, schoolId]);

  useEffect(() => {
    growthbook.init({ streaming: false });
  }, []);

  return (
    <GrowthBookProvider growthbook={growthbook}>{children}</GrowthBookProvider>
  );
};

export default ExperimentsProvider;
